module.exports = __webpack_public_path__ + "img/BlinkArt_Spear1H_Epic.88b53d28.png";